import { IState } from 'core/types';

export const getIsLoggedIn = ({ auth: { isLoggedIn } }: IState) => isLoggedIn;

export const getIsAuthLoading = ({ auth: { isAuthLoading } }: IState) => isAuthLoading;

export const getAuthServerError = ({ auth: { authServerError } }: IState) => authServerError;

export const getUsername = ({ user: { username } }: IState) => username;
